/**
 * Step 0 — Manual mode.
 *
 * Plain markdown textarea pre-filled with the ISO/SAE 21434 template
 * + "Save & Start Analysis" CTA. Dumb renderer; lifecycle in
 * `useManualItemDefinition`.
 */
import React from 'react';
import type { ManualFlowState } from '../stepBodyProps';
import { Button } from '../../../../components/ui/Button2';
import { TypographyMuted } from '../../../../components/ui/Typography';
import styles from './ManualMode.module.css';

// Button2 is a JSX forwardRef primitive; cast for use from TSX (mirrors the
// ButtonAny convention across the step-components).
const ButtonAny = Button as unknown as React.ComponentType<any>;

export default function ManualMode({ markdown, saving, error, onChange, onSubmit }: ManualFlowState) {
  return (
    <section className={styles.section}>
      <header className={styles.header}>
        <h2 className={styles.title}>Manual Item Definition</h2>
        <TypographyMuted className={styles.helper}>
          Edit the ISO/SAE 21434 template below. The analysis agent will use this content directly
          instead of extracting it from a document.
        </TypographyMuted>
      </header>
      <div className={styles.editorWrap}>
        <textarea
          className={styles.editor}
          value={markdown}
          onChange={(e) => onChange(e.target.value)}
          disabled={saving}
          spellCheck={false}
          placeholder="Author your Item Definition in Markdown…"
        />
      </div>
      {error && <div className={styles.errorBanner}>{error}</div>}
      <div className={styles.actions}>
        <ButtonAny
          variant="default"
          loading={saving}
          disabled={!markdown.trim()}
          onClick={onSubmit}
        >
          {saving ? 'Saving…' : 'Save & Start Analysis'}
        </ButtonAny>
      </div>
    </section>
  );
}
